<template>
    <div class="kgk-team-details">
        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
        <div v-else>
            <div v-if="team">
                <h1>Mein Team</h1>
                <p>
                    Du bist Mitglied des Teams <b>{{ team.name }}</b>.<br>
                    Ihr seid<span v-if="team.compete_date"> seit {{ convertDatetimeReadable(team.compete_date) }} Uhr</span> zusammen bisher {{ convertNumberReadable(Math.round(totalLength * 100) / 100) }} km in {{ totalRunCount }} {{ totalRunCount == 1 ? 'Lauf' : 'Läufen' }} gelaufen.
                    
                </p>

                <!-- <div v-if="team.members.length > 150" style="color:#ff0000">
                    <p>
                        <b>Achtung!</b>
                        Die Wertung im Ranking hat sich dieses Jahr wieder auf die absolut gelaufenen Gesamtkilometer pro Team geändert. Daher sind die Teams erneut auf eine Größe von 150 Personen beschränkt.
                        Euer Team hat aktuell mehr als 150 Mitglieder und <b>erscheint daher nicht im Ranking</b> (erst wenn ihr wieder maximal 150 Mitglieder seid).
                    </p>
                </div> -->

                <h3>{{ team.name }}</h3>
                <table>
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th>Teilnehmer</th>
                            <th>Firma</th>
                            <th>Wettbewerb</th>
                            <th>Gelaufene km</th>
                            <th>Anzahl Läufe</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in team.members"
                            :key="user.identifier">
                            <td>
                                <div class="kgk-avatar kgk-avatar--list" v-kgk-avatar="user.avatar_url"></div>
                            </td>
                            <td>
                                <div class="kgk-mobile-th">Teilnehmer:</div>
                                {{ user.username }}<br>
                            </td>
                            <td>
                                <div class="kgk-mobile-th">Firma:</div>
                                {{ user.company || '&ndash;' }}
                            </td>
                            <td>
                                <div class="kgk-mobile-th">Wettbewerb:</div>
                                {{ user.competitive ? 'Ja' : 'Nein' }}
                            </td>
                            <td>
                                <div class="kgk-mobile-th">Gelaufene km:</div>
                                {{ convertNumberReadable(user.total_length, 2) }} km
                            </td>
                            <td>
                                <div class="kgk-mobile-th">Anzahl Läufe:</div>
                                {{ user.run_count }}
                            </td>
                            <td>
                                <div class="kgk-mobile-th">Aktionen:</div>
                                <div class="kgk-actions">
                                    <a v-if="!user.is_self" @click.prevent="removeMemberButton(user)" href="#" v-tooltip="'Läufer aus Team entfernen'">
                                        <i class="fas fa-minus-circle"></i>
                                    </a>
                                    <i v-else class="fas fa-user" v-tooltip="'Das bist du selbst'"></i>
                                </div>
                            </td>
                        </tr>
                        <!--<tr v-if="canInviteUser">
                            <td colspan="6" style="text-align:right;">
                                <a @click.prevent="addMemberButton()" href="#" title="Mitglied hinzufügen">
                                    Mitglied hinzufügen
                                </a>
                            </td>
                            <td>
                                <a @click.prevent="addMemberButton()" href="#" title="Mitglied hinzufügen">
                                    <i class="fas fa-user-plus"></i>
                                </a>
                            </td>
                        </tr>-->
                        <tr>
                            <td class="kgk-mobile-td-hidden">&nbsp;</td>
                            <td class="kgk-mobile-td-hidden">&nbsp;</td>
                            <td class="kgk-mobile-td-hidden">&nbsp;</td>
                            <td class="kgk-mobile-td-hidden">&nbsp;</td>
                            <td>
                                <div class="kgk-mobile-th">Gelaufene km gesamt:</div>
                                <b>&sum; {{ convertNumberReadable(totalLength, 2) }} km</b>
                            </td>
                            <td>
                                <div class="kgk-mobile-th">Anzahl Läufe gesamt:</div>
                                <b>&sum; {{ totalRunCount }}</b>
                            </td>
                            <td class="kgk-mobile-td-hidden">&nbsp;</td>
                        </tr>
                    </tbody>
                </table>

                <!--<br>-->
                <div class="spacer"></div>

                <TeamInvite :can-invite="canInviteUser" :team-identifier="team.identifier" @invited="loadTeamDetails()" />

                <!--<br>-->
                <div class="spacer-small"></div>

                <TeamInvitesList :invites="team.invites" :team-is-full="!canInviteUser" :members="team.members" @cancelled="loadTeamDetails()" />

                <!--<br><br>-->
                <div class="spacer"></div>

                <TeamLeave :team-name="team.name" @left="loadTeamDetails()" />

                <!--
                <table>
                    <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Distanz</th>
                        <th>Dauer</th>
                        <th>Pace</th>
                        <th>Zeitpunkt</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(run, index) in runs"
                        :item="run"
                        :key="run.identifier">
                        <td>{{ runs.length - index }}.</td>
                        <td>{{ Math.round(run.length * 100) / 100 }} km</td>
                        <td>{{ run.duration }} Minuten</td>
                        <td>{{ Math.round(run.duration / run.length * 100) / 100 }} min/km</td>
                        <td>{{ run.ran_at }}</td>
                        <td><i class="fas fa-edit"></i></td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                        <td><b>&sum; {{ Math.round(totalLength * 100) / 100 }} km</b></td>
                        <td><b>&sum; {{ totalDuration }} Minuten</b></td>
                        <td><b>&Oslash; {{ Math.round(averagePace * 100) / 100 }} min/km</b></td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    </tbody>
                </table>
                -->
            </div>
            <div v-else>
                <Teamless @triggerReload="loadTeamDetails()" />
            </div>
        </div>
    </div>
</template>

<script>
    import user from '../../api/user';
    import team from '../../api/team';

    import TeamInvite from './TeamInvite';
    import TeamInvitesList from './TeamInvitesList';
    import TeamLeave from './TeamLeave';
    import Teamless from './Teamless';

    export default {
        name: 'TeamDetails',
        components: {
            TeamInvite,
            TeamInvitesList,
            TeamLeave,
            Teamless
        },
        props: {
            //msg: String
        },
        data() {
            return {
                team: null,
                loading: false,
                error: null,
                inviteId: '',
                acceptInviteMass: false,
                user: {
                    session_valid:true,
                    run_type:0,
                    identifier:'',
                },
            }
        },
        computed: {
            totalLength() {
                if(this.team != null){
                    return this.team.members.reduce((total, user) => total + user.total_length, 0);
                }
            },
            totalRunCount() {
                if(this.team != null){
                    return this.team.members.reduce((total, user) => total + user.run_count, 0);
                }
            },
            canInviteUser() {
                return true;
                // return this.team.members.length < 150; // @TODO: team max size magic number
            },
            userIsLoggedIn(){
                if(this.user.identifier != ""){
                    return true;
                }else{
                    return false;
                }
            }
        },
        methods: {
            loadTeamDetails() {
                this.loading = true;

                user.getTeam(
                    this,
                    data => {
                        this.team = data.team;
                        // ✅ Now fetch invites right after team loads
                        this.loadTeamInvites();
                    },
                    (e) => {
                        // The API returns 400 for "not part of a team" -- that's
                        // a normal state (renders <Teamless>), not an error.
                        if (e.response && e.response.status === 400) {
                            this.team = null;
                        } else {
                            this.error = 'Es ist ein Fehler aufgetreten';
                        }
                    },
                    () => this.loading = false,
                );
            },
            loadTeamInvites() {
                user.getTeamInvites(
                    this,
                    data => {
                        
                        // Use $set to ensure Vue detects the change
                        this.$set(this.team, 'invites', data.invites || []);
                    },
                    () => {
                        this.$set(this.team, 'invites', []);
                    },
                );
            },
            loadUserDetails() {
                this.loading = true;
                user.getDetails(
                    this,
                    data => {
                        this.user = data.user;
                        this.checkIfRedirectNeeded();
                    },
                    () => this.error = 'Es ist ein Fehler aufgetreten',
                    () => {
                        this.loading = false;
                        this.checkIfRedirectNeeded();
                    },
                );
            },
            removeMemberButton(member) {
                const _this = this;

                let fired = false;

                this.$modal.show('dialog', {
                    title: 'Teammitglied entfernen',
                    text: `Möchten Sie <b>${member.username}</b> wirklich aus dem Team enfernen?`,
                    buttons: [
                        {
                            title: 'Abbrechen',
                            default: true,
                        },
                        {
                            title: 'Ja, entfernen',
                            handler() {
                                if( fired ) {
                                    return;
                                }

                                fired = true;
                                this.title += ' <i class="fas fa-spinner fa-spin"></i>';
                                _this.removeMember(member, () => _this.$modal.hide('dialog'));
                            }
                        }
                    ]
                });
            },
            removeMember(member, finallyCallback) {
                team.removeMember(
                    this,
                    member.identifier,
                    () => {
                        //console.log(data);

                        this.loadTeamDetails();

                        this.$notify({
                            type: 'success',
                            title: 'Teammitglied entfernt',
                            text: `Läufer ${member.username} wurde erfolgreich aus deinem Team entfernt.`
                        });
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        if( finallyCallback ) {
                            finallyCallback();
                        }
                    }
                )
            },
            checkIfRedirectNeeded(){
                
                if(this.$route.params.acceptInviteMass == "acceptInviteMass"){
                    this.acceptInviteMass = true;
                    this.inviteId = this.$route.params.inviteId;
                }
            
                if(!this.userIsLoggedIn){
                    this.$parent.$parent.redirectAfterLogin = true;
                    this.$parent.$parent.redirectAfterLoginTo = this.$route.path;
                    this.$router.push(this.acceptInviteMass ? `/login/${this.inviteId}` : '/login');
                }else{
                    if(this.acceptInviteMass){
                        this.acceptInvite(this.inviteId);
                    }
                }
            },
            acceptInvite(inviteId) {
                
                user.acceptInviteMass(
                    this,
                    inviteId,
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'Einladung angenommen',
                            text: `Du bist nun Mitglied des Teams.`
                        });

                        this.$router.push('/team');
                        this.$router.go(0);
                            this.$nextTick(() => {
                                this.$notify({
                                    type: 'success',
                                    title: 'Einladung angenommen',
                                    text: `Du bist nun Mitglied des Teams..`
                                });
                            });
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                );
            },
        },
        mounted() {
            this.loadTeamDetails();
            this.loadUserDetails();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
